// extracted by mini-css-extract-plugin
export default {"container":"NewsFrameTitle_container__piEp3","title":"NewsFrameTitle_title__rYwCe","subtitle":"NewsFrameTitle_subtitle__MfsPF","link":"NewsFrameTitle_link__iKkka"};